<button matRipple class="btn col-control-action" [matMenuTriggerFor]="menu">
  <i class="fa fa-ellipsis-v" aria-hidden="true" aria-label="menu"></i>
</button>

<mat-menu #menu="matMenu">
  @for (itemButton of actions; track itemButton) {
    <div mat-menu-item (click)="onClick(itemButton)" [style]="itemButton.cssStyle">
      @if (itemButton.icon) {
        <i class="col-control-button-icon" [class]="itemButton.icon"></i>
      }
      {{ itemButton.translate ? (itemButton.title | cxTranslate) : itemButton.title }}
    </div>
  }
</mat-menu>
